<template>
  <div class="tabContainer">
    <div class="rule-item" v-for="(item, index) in styleConditionData">
      <div class="rule-head rule-flex">
        <el-input v-model="item.ruleName" size="small" style="width: 240px;"></el-input>
        <div class="rule-head-right rule-flex ">
          <el-button
              size="small"
              @click="handleAddRule"
          >
            添加
          </el-button>
          <el-button
              size="small"
              @click="handleRemoveRule(index)"
              v-show="styleConditionData.length > 1"
          >
            删除
          </el-button>
        </div>
      </div>
      <el-form-item label="作用于" label-width="auto" label-position="left" v-if="componentNape === 'sheet'">
        <el-radio-group v-model="item.scope">
          <el-radio label="current">当前列</el-radio>
          <el-radio
              label="all"
              :disabled="(styleConditionData || []).find(item => item.scope === 'all') && item.scope !== 'all'"
              :class="item.scope === 'all' ? 'all-red' : ''"
          >所有列
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <ruleFilter
          :linkData="linkData"
          :data="item.conditions"
          :isPageVar="true"
          :level="1"
          :formDef="defaultForm"
          :selectArr="selectArr"
          :unsupportedOperators="unsupportedOperators"
          :styleConfig="styleConfig"
      ></ruleFilter>
      <div class="rule-flex" v-if="componentNape === 'map'">
        <el-form-item
            label="区块色"
            labelAlign="left"
        >
          <el-color-picker
              :predefine="predefineColors"
              v-model="item.areaColor"
          ></el-color-picker>
        </el-form-item>
      </div>
      <div class="rule-flex" v-if="componentNape === 'sheet'">
        <el-form-item
            label="字色"
            labelAlign="left"
        >
          <el-color-picker
              :predefine="predefineColors"
              v-model="item.fontColor"
          ></el-color-picker>
        </el-form-item>
        <el-form-item labelAlign="left" label="字号">
          <el-input-number style="width: 100px;" min='0' v-model="item.fontSize" size="small"
                           controls-position="right"/>
        </el-form-item>
        <el-form-item labelAlign="left" label="字重">
          <el-radio-group v-model="item.fontWeight">
            <el-radio label="normal">普通</el-radio>
            <el-radio label="bolder">加粗</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
            label="单元格"
            labelAlign="left"
        >
          <el-color-picker
              :predefine="predefineColors"
              v-model="item.bgColor"
          ></el-color-picker>
        </el-form-item>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, ref, watch} from "vue";
import {deepClone} from '@/echart/util'
import {ElMessage} from "element-plus";
import ruleFilter from "./Rule.vue";
import {CARD_TYPE, predefineColors} from "@/option/common/dict.js";


const props = defineProps({
  linkData: {
    type: Object,
    default() {
      return {};
    },
  },
  componentNape: {
    type: String,
    default: '',
  },
  modelValue: {
    type: Boolean,
  },
  option: {
    type: Object,
    default() {
      return {}
    }
  },
  styleConditionList: {
    type: Array,
    default: [],
  }
});

const rawRuleItem = {
  id: 1,
  type: '',
  ruleName: '',
  scope: 'current',
  conditions: {
    operationSymbol: "and",
    rows: [
      {
        ruletype: "d",
        id: "1",
      },
    ],
  },
  fontColor: '',
  fontSize: '',
  bgColor: '',
}

let styleConditionData = ref([deepClone(rawRuleItem)])

if (props.styleConditionList) {
  styleConditionData.value = deepClone(props.styleConditionList)
}

watch(
    props.styleConditionList,
    (newVal, oldVal) => {
      styleConditionData.value = deepClone(props.styleConditionList)
    },
    {immediate: true, deep: true}
);
const styleConfig = ref({
  size: 'small',
})

const unsupportedOperators = ref([
  {
    key: "in",
    label: "包含(in)",
    fieldShowArr: ["String", "string", "Number", "int", "double", "Dict", "Assignee", "Ref", "ExteriorRef"],
  },
  {
    key: "not in",
    label: "不包含(not in)",
    fieldShowArr: ["String", "string", "Number", "int", "double", "Dict", "Assignee", "Ref", "ExteriorRef"],
  },
  {key: "left like", label: "左匹配(left like)", fieldShowArr: ["String", "string"]},
  {key: "like", label: "匹配(Like)", fieldShowArr: ["String", "string"]},
  {
    key: "is null",
    label: "为空(is null)",
    fieldShowArr: ["String", "string", "Number", "int", "double", "Dict", "Date", "Assignee", "Ref", "ExteriorRef"],
  },
  {
    key: "is not null",
    label: "不为空(is not null)",
    fieldShowArr: ["String", "string", "Number", "int", "double", "Dict", "Date", "Assignee", "Ref", "ExteriorRef"],
  },
  {key: "[a,b]", label: "闭区间([a,b])", fieldShowArr: ["Number", "int", "double", "Date"]},
  {key: "period", label: "周期(period)", fieldShowArr: ["Date"]},
  {
    key: "max",
    label: "最大值(max)",
    fieldShowArr: ["Date"],
  },
  {
    key: "min",
    label: "最小值(min)",
    fieldShowArr: ["Date"],
  },
])

const defaultForm = {};
const selectArr = computed(() => {
  const {
    columns = [],
    groups = [],
    metrics = [],
    rows = [],
  } = props?.option
  const arr = [...columns, ...metrics, ...rows]

  return arr.map(item => {
    return item.type === 'cus' ? {
      ...item,
      fieldType: 'Number',
    } : item
  })
})


const handleAddRule = () => {
  styleConditionData.value.push(deepClone(rawRuleItem))
}

const handleRemoveRule = (index) => {
  styleConditionData.value.splice(index, 1)
}


defineExpose({
  styleConditionData,
});
</script>

<style lang="scss" scoped>
.tabContainer {
  width: 100%;
  max-height: 500px;
  overflow-y: auto;

  :deep(.el-form-item__label) {
    padding-left: 0;
  }

  .rule-item {
    padding: 8px;
    border-radius: 5px;
    width: 100%;
    box-sizing: border-box;
    margin-bottom: 10px;

    .rule-head {
      justify-content: space-between;
      align-items: center;
    }

    .rule-head-right {
      align-items: center;
    }
  }

  .rule-flex {
    display: flex;
  }

  .all-red {
    :deep(.el-radio__input.is-checked + .el-radio__label) {
      color: red;
    }

    :deep(.el-radio__input.is-checked .el-radio__inner) {
      color: red;
      border-color: red;
      background: red;
    }
  }
}
</style>
